(function($) {
    /*"use strict"; */ // Start of use strictrt of use strict

    $('<div class="overlay" />').appendTo('.nav--primary__handler').on('click', function() {
        $('body').removeClass("has-nav-open");
    });

    $(".nav--primary__icon").on('click', function(event){
        event.preventDefault();
        $('.nav--primary__handler').toggleClass("has-nav-open");
    });

})(jQuery); // End of use strict
